const STORAGE_PREFIX = 'misoft_chat';

/**
 * Ключ в localStorage для кода диалога (уникальный на пару tokenCode + домен).
 */
function getCodeStorageKey(tokenCode) {
  return `${STORAGE_PREFIX}_code_${tokenCode || 'default'}`;
}

/**
 * Генерирует уникальный код клиента (UUID v4-подобный).
 */
function generateCode() {
  const hex = '0123456789abcdef';
  let result = '';
  for (let i = 0; i < 36; i++) {
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      result += '-';
    } else if (i === 14) {
      result += '4';
    } else {
      result += hex[Math.floor(Math.random() * 16)];
    }
  }
  return result;
}

/**
 * Возвращает существующий код диалога из localStorage или создаёт, сохраняет и возвращает новый.
 * @param {string} tokenCode - Код токена канала (при добавлении виджета).
 * @returns {string} Уникальный код диалога (клиента).
 */
export function getOrCreateDialogCode(tokenCode) {
  const key = getCodeStorageKey(tokenCode);
  try {
    let code = typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null;
    if (!code) {
      code = generateCode();
      localStorage.setItem(key, code);
    }
    return code;
  } catch (e) {
    return generateCode();
  }
}

const SESSION_ID_KEY = 'sessionId';
const SESSION_ID_GUID = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

/**
 * Текущий sessionId клиента портала из localStorage (GUID) или null.
 */
export function readSessionId() {
  try {
    if (typeof localStorage === 'undefined') return null;
    const value = localStorage.getItem(SESSION_ID_KEY);
    if (!value || value === 'null' || value === 'undefined') return null;
    const trimmed = value.trim();
    if (!SESSION_ID_GUID.test(trimmed)) return null;
    return trimmed;
  } catch (e) {
    return null;
  }
}

/**
 * Следит за sessionId. Вызывает onChange только при появлении или смене непустого GUID.
 * @returns {function} отписка
 */
export function watchSessionId(onChange) {
  let last = readSessionId() || '';
  const check = () => {
    const now = readSessionId() || '';
    if (now === last) return;
    last = now;
    if (now) onChange(now);
  };
  const onStorage = (e) => {
    if (e.key === SESSION_ID_KEY || e.key == null) check();
  };
  if (typeof window !== 'undefined') {
    window.addEventListener('storage', onStorage);
  }
  const interval = setInterval(check, 1000);
  return () => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('storage', onStorage);
    }
    clearInterval(interval);
  };
}
